// store.js
import { reactive } from 'vue'

export const store = reactive({
  loading: false,
})
